import React, { useState, useEffect } from 'react';

const AdminPanel = () => {
  const [registrations, setRegistrations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchRegistrationData();
  }, []);

  // Fetch all registered users from backend
  const fetchRegistrationData = async () => {
    try {
      setLoading(true);
      const response = await fetch(process.env.REACT_APP_API_URL+"/admineventposter");
      if (!response.ok) throw new Error("Failed to fetch data");
      const data = await response.json();
      setRegistrations(data);
      setError(null);
    } catch (err) {
      setError("Failed to fetch registration data");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // Delete a user by ID
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this registration?")) return;
    try {
      const response = await fetch(process.env.REACT_APP_API_URL+`/admineventposter/${id}`, {
        method: "DELETE",
      });
      if (!response.ok) throw new Error("Delete failed");
      setRegistrations(prev => prev.filter(reg => reg._id !== id)); // Use MongoDB _id
    } catch (err) {
      setError("Failed to delete registration");
      console.error(err);
    }
  };

  const refreshData = () => {
    fetchRegistrationData();
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div className="admin-panel">
      <h2>Admin Panel - Registrations</h2>
      {error && <div style={{ color: "red" }}>{error}</div>}

      <button onClick={refreshData}>Refresh</button>

      {registrations.length === 0 ? (
        <p>No registrations found.</p>
      ) : (
        <table border="1" cellPadding="10">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Place</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {registrations.map((reg, index) => (
              <tr key={reg._id}>
                <td>{index + 1}</td>
                <td>{reg.name}</td>
                <td>{reg.mail}</td>
                <td>{reg.phone}</td>
                <td>{reg.place}</td>
                <td>
                  <button onClick={() => handleDelete(reg._id)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default AdminPanel;
